import React from 'react'
import { Hide } from 'pcln-design-system'
import ExtendStay from '@/components/ExtendStay'
import useBootstrapData from '@/hooks/useBootstrapData'
import TripGrouping from '@/components/TripGrouping/TripGrouping'
import TripActivity from '@/components/TripActivity/TripActivity'
import useTripBookings from '@/hooks/useTripBookings'
import useGrowthLoopAudiences from '@/hooks/useGrowthLoopAudiences'
import useClientSideSignedInData from '@/hooks/useClientSideSignedInData'

type TripDisplayOrderProps = {
  isLandingPage?: boolean
}

export default function TripDisplayOrder({
  isLandingPage = false
}: TripDisplayOrderProps) {
  const {
    webstats: { clientGUID },
    appName,
    appVersion,
    signInStatus: { signedIn: serverSignedIn },
    customer: { emailAddress: serverEmailAddress }
  } = useBootstrapData()

  const { signedIn: clientSideSignedIn, email: clientSideEmail } =
    useClientSideSignedInData()

  const signedIn = serverSignedIn || clientSideSignedIn
  const emailAddress = serverEmailAddress || clientSideEmail || ''
  const growthLoopAudiences = useGrowthLoopAudiences(
    emailAddress,
    appName,
    appVersion
  )

  const {
    extendStayBooking,
    tripGroupingBooking,
    tripGroupingAbandonedSelection,
    defaultAbandonedSelection
  } = useTripBookings(clientGUID, appName, appVersion, emailAddress, signedIn)

  if (signedIn) {
    if (extendStayBooking) {
      return (
        <>
          <Hide md mb={4}>
            <ExtendStay {...extendStayBooking} />
          </Hide>
          <TripActivity
            productType={['STAY', 'FLY', 'DRIVE']}
            pageName="homepage"
            shouldUseSmallerHeading
          />
        </>
      )
    }

    return (
      <TripGrouping
        growthLoopAudiences={growthLoopAudiences}
        isLandingPage={isLandingPage}
        tripGroupingBooking={tripGroupingBooking}
        tripGroupingAbandonedSelection={tripGroupingAbandonedSelection}
        defaultAbandonedSelection={defaultAbandonedSelection}
      />
    )
  }

  return (
    <TripActivity
      productType={['STAY', 'FLY', 'DRIVE']}
      pageName="homepage"
      shouldUseSmallerHeading={false}
    />
  )
}
